// Eknoor Driving School - shared constants

export const SCHOOL = {
  name: "Eknoor Driving School",
  shortName: "Eknoor",
  tagline: "G2 and G lessons, packages, and road-test car service across the GTA.",
  phoneDisplay: "+1 (905) 906-7361",
  phoneLink: "tel:+19059067361",
  whatsappLink: "https://wa.me/19059067361?text=Hi%20Eknoor%2C%20I%27d%20like%20to%20ask%20about%20driving%20lessons.",
  email: "info@eknoordrivingschool.ca",
  emailLink: "mailto:info@eknoordrivingschool.ca",
  mapsLink: "https://maps.app.goo.gl/gWAtrS5kPAaWe3qw6?g_st=iwb",
  serviceArea: "GTA & surrounding area covered",
  hours: "Classes run 6 AM to 10 PM, 7 days a week",
};

export const NAV_LINKS = [
  { id: "home", label: "Home" },
  { id: "packages", label: "Packages" },
  { id: "wins", label: "Wins" },
  { id: "areas", label: "Areas" },
  { id: "faq", label: "FAQ" },
  { id: "contact", label: "Contact" },
];

// Student road-test wins.
// Drop matching photos into frontend/public/students/ using the file names below.
// Recommended: JPG/WebP, ~1200px on longest edge, < 300 KB each.
export const STUDENT_WINS = [
  { src: "/students/01.jpeg", alt: "Student celebrating outside the testing centre", track: "G2" },
  { src: "/students/02.jpeg", alt: "Student in car giving a thumbs up", track: "G2" },
  { src: "/students/03.jpeg", alt: "Student holding her brand-new temporary licence", track: "G2" },
  { src: "/students/04.jpeg", alt: "Student showing licence card and slip", track: "G2" },
  { src: "/students/05.jpeg", alt: "Student outdoors with licence paper, pointing up", track: "G" },
  { src: "/students/06.jpeg", alt: "Student giving peace sign after passing", track: "G2" },
  { src: "/students/07.jpeg", alt: "Student walking back with paperwork in hand", track: "G" },
  { src: "/students/08.jpeg", alt: "Student with their fresh licence beside instructor", track: "G2" },
  { src: "/students/09.jpeg", alt: "Friends together after passing their road tests", track: "G2" },
  { src: "/students/10.jpeg", alt: "Student holding licence card and slip in car", track: "G" },
  { src: "/students/11.jpeg", alt: "Student outside parked Eknoor training car", track: "G2" },
  { src: "/students/12.jpeg", alt: "Student in winter coat smiling with licence", track: "G2" },
];

export const WIN_STATS = [
  { value: 3000, suffix: "+", label: "Road tests passed" },
  { value: 5,    suffix: "+", label: "Years experience" },
  { value: 16,   suffix: "",  label: "GTA cities served" },
];

export const STATS = [
  { value: "5+", label: "Years coaching" },
  { value: "3,000+", label: "Road tests passed" },
  { value: "16", label: "GTA cities served" },
  { value: "95%", label: "Road-test focus" },
];

export const PACKAGES = [
  {
    id: "package-1",
    track: "ROAD",
    trackLabel: "Package 1",
    lessons: 2,
    price: 320,
    priceNote: "Package price plus tax",
    bg: "frost",
    displayTitle: "Package 1",
    displaySubtitle: "2 lessons + local road test car",
    audience: "Local road test package",
    bestFor: "Drivers who want two focused lessons and the dual-brake car for a local G2 / G road test.",
    highlights: [
      "2 lessons",
      "Car for local road test: $200",
      "Package price: $320 plus tax",
      "Pickup and drop-off included within 4-5 km",
    ],
    learnMore: {
      intro:
        "Package 1 combines 2 lessons with the car for a local road test.",
      included: [
        "2 in-car driving lessons",
        "Dual-brake car for the G2 / G road test",
        "Local road test car fee included at $200",
        "Pickup and drop-off included within 4-5 km for local road test service",
        "Package price is $320 plus tax",
      ],
      whyChoose: [
        "Good for quick road-test polish",
        "Keeps your local road test car booking bundled with lessons",
        "Appointment-only scheduling by call, text, or WhatsApp",
      ],
    },
  },
  {
    id: "package-2",
    track: "ROAD",
    trackLabel: "Package 2",
    lessons: 4,
    price: 440,
    priceNote: "Package price plus tax",
    bg: "sky",
    displayTitle: "Package 2",
    displaySubtitle: "4 lessons + local road test car",
    audience: "Local road test package",
    bestFor: "Drivers who want more practice before test day plus the local road-test car booking.",
    highlights: [
      "4 lessons",
      "Car for local road test: $200",
      "Package price: $440 plus tax",
      "Pickup and drop-off included within 4-5 km",
    ],
    learnMore: {
      intro:
        "Package 2 combines 4 lessons with the car for a local road test.",
      included: [
        "4 in-car driving lessons",
        "Dual-brake car for the G2 / G road test",
        "Local road test car fee included at $200",
        "Pickup and drop-off included within 4-5 km for local road test service",
        "Package price is $440 plus tax",
      ],
      whyChoose: [
        "More time for turns, lane changes, parking, and observation",
        "Road-test car is bundled into the package price",
        "Appointment-only scheduling by call, text, or WhatsApp",
      ],
    },
  },
  {
    id: "package-3",
    track: "ROAD",
    trackLabel: "Package 3",
    lessons: 7,
    price: 600,
    original: 620,
    priceNote: "Discounted package price plus tax",
    bg: "peachCream",
    displayTitle: "Package 3",
    displaySubtitle: "7 lessons + local road test car",
    audience: "Discounted price",
    bestFor: "Drivers who want a fuller prep plan with a discounted package total.",
    highlights: [
      "7 lessons at discounted package pricing",
      "Car for local road test: $200",
      "$620 regular total",
      "$600 package price plus tax",
    ],
    learnMore: {
      intro:
        "Package 3 includes 7 lessons at a discounted price plus the car for a local road test.",
      included: [
        "7 in-car driving lessons",
        "Dual-brake car for the G2 / G road test",
        "Local road test car fee included at $200",
        "Regular total $620, discounted to $600",
        "Package price is $600 plus tax",
      ],
      whyChoose: [
        "Discounted package for extra driving practice",
        "Built for students who need repeated road-test drills",
        "Appointment-only scheduling by call, text, or WhatsApp",
      ],
    },
  },
  {
    id: "package-4",
    track: "ROAD",
    trackLabel: "Package 4",
    lessons: 10,
    price: 750,
    original: 800,
    priceNote: "Discounted package price plus tax",
    bg: "gold",
    displayTitle: "Package 4",
    displaySubtitle: "10 lessons + local road test car",
    audience: "Discounted price",
    bestFor: "Newer or nervous drivers who want deeper prep before the G2 / G road test.",
    highlights: [
      "10 lessons at discounted package pricing",
      "Car for local road test: $200",
      "$800 regular total",
      "$750 package price plus tax",
    ],
    learnMore: {
      intro:
        "Package 4 includes 10 lessons at a discounted price plus the car for a local road test.",
      included: [
        "10 in-car driving lessons",
        "Dual-brake car for the G2 / G road test",
        "Local road test car fee included at $200",
        "Regular total $800, discounted to $750",
        "Package price is $750 plus tax",
      ],
      whyChoose: [
        "Strong option for confidence building",
        "More time for city driving, parking, observation, and road-test habits",
        "Appointment-only scheduling by call, text, or WhatsApp",
      ],
    },
  },
  {
    id: "package-5",
    track: "ROAD",
    trackLabel: "Package 5",
    lessons: 15,
    price: 1000,
    original: 1100,
    priceNote: "Discounted package price plus tax",
    bg: "charcoal",
    displayTitle: "Package 5",
    displaySubtitle: "15 lessons + local road test car",
    audience: "Discounted price",
    bestFor: "Drivers who want the most practice time and a bundled local road-test car.",
    highlights: [
      "15 lessons at discounted package pricing",
      "Car for local road test: $200",
      "$1100 regular total",
      "$1000 package price plus tax",
    ],
    learnMore: {
      intro:
        "Package 5 includes 15 lessons at a discounted price plus the car for a local road test.",
      included: [
        "15 in-car driving lessons",
        "Dual-brake car for the G2 / G road test",
        "Local road test car fee included at $200",
        "Regular total $1100, discounted to $1000",
        "Package price is $1000 plus tax",
      ],
      whyChoose: [
        "Best fit when you want maximum practice before test day",
        "Includes the largest package discount",
        "Appointment-only scheduling by call, text, or WhatsApp",
      ],
    },
  },
  {
    id: "package-6",
    track: "ROAD",
    trackLabel: "Package 6",
    lessons: 20,
    price: 1250,
    original: 1400,
    priceNote: "Discounted package price plus tax",
    bg: "silver",
    displayTitle: "Package 6",
    displaySubtitle: "20 lessons + local road test car",
    audience: "Best value package",
    bestFor: "Drivers who want a full confidence-building plan with the biggest lesson bundle and road-test car included.",
    highlights: [
      "20 lessons at discounted package pricing",
      "20 x $60 lessons = $1,200",
      "Car for local road test: $200",
      "$1,400 regular total",
      "$1,250 package price plus tax",
      "Save $150",
    ],
    learnMore: {
      intro:
        "Package 6 includes 20 lessons at a discounted price plus the car for a local road test.",
      included: [
        "20 in-car driving lessons",
        "Dual-brake car for the G2 / G road test",
        "20 lessons at $60 = $1,200",
        "Local road test car fee included at $200",
        "Regular total $1,400, discounted to $1,250",
        "Package price is $1,250 plus tax",
      ],
      whyChoose: [
        "Best value when you want the most guided practice",
        "Useful for newer drivers who want steady coaching before test day",
        "Appointment-only scheduling by call, text, or WhatsApp",
      ],
    },
  },
  {
    id: "bde-course",
    track: "BDE",
    trackLabel: "BDE Course",
    lessons: 10,
    price: 849,
    original: 899,
    priceNote: "Discounted course price plus tax",
    bg: "iosPurple",
    displayTitle: "BDE Course",
    displaySubtitle: "30 hours online + 10 hours in-car + road test car",
    audience: "Discounted course bundle",
    bestFor: "New drivers who want the BDE course with in-car lessons and the car for road test day.",
    highlights: [
      "$699 BDE course",
      "30 hours online + 10 hours in-car lessons",
      "$200 car for road test",
      "$849 discounted price plus tax",
    ],
    learnMore: {
      intro:
        "The BDE Course bundle combines online training, in-car lessons, and the car for road test day at a discounted price.",
      included: [
        "$699 BDE course",
        "30 hours online",
        "10 hours in-car lessons",
        "$200 car for road test",
        "$899 regular total, discounted to $849",
        "Discounted course price is $849 plus tax",
      ],
      whyChoose: [
        "Bundles online learning with in-car practice",
        "Includes the road-test car add-on",
        "Appointment-only scheduling by call, text, or WhatsApp",
      ],
    },
  },
];

export const SERVICE_AREAS = [
  "Toronto",
  "Mississauga",
  "Brampton",
  "Scarborough",
  "Markham",
  "Vaughan",
  "Richmond Hill",
  "Oakville",
  "Burlington",
  "Etobicoke",
  "North York",
  "Ajax",
  "Pickering",
  "Whitby",
  "Oshawa",
  "Milton",
];

export const TESTIMONIALS = [
  {
    name: "Mihir Agarwal",
    city: "Facebook Review",
    rating: 5,
    quote:
      "The instructor, Jaideep, was quite well versed with rules and was able to communicate it well. The teaching style is quite good and would highly recommend!",
  },
  {
    name: "Vaibhav Singh Choudhary",
    city: "Facebook Review",
    rating: 5,
    quote:
      "Great experience with Jaideep! He was patient, clear, and really helped build my confidence for the G2 test. His tips on parking and test routes made a big difference. Passed on my first try \u2014 highly recommend!",
  },
  {
    name: "Vittorio Wang",
    city: "Facebook Review",
    rating: 5,
    quote:
      "Got my G2 first time with this guy after failing about 4 times with another guy \ud83d\ude2c \u2014 great guy!",
  },
  {
    name: "Hikmat Khan",
    city: "Facebook Review",
    rating: 5,
    quote:
      "Jaideep Gaind is an amazing instructor who truly goes above and beyond. His friendly and supportive approach makes everything easy to understand. I highly recommend him \u2014 I passed my G2 on the first attempt because of his guidance and patient behaviour.",
  },
  {
    name: "Tomi Oyeleke",
    city: "Facebook Review",
    rating: 5,
    quote:
      "Great instructor, I would highly recommend. I passed my G test on the first attempt. He is worth the money you pay for his service.",
  },
  {
    name: "Ree-tika Aryal",
    city: "Facebook Review",
    rating: 5,
    quote:
      "I am a tough student and he knew exactly how to teach me. I passed in my first attempt and have never been this happy in my life.",
  },
];

export const SOCIAL = {
  facebook: "https://www.facebook.com/share/1JDRAH5RzC/?mibextid=wwXIfr",
  tiktok: "https://www.tiktok.com/@learnwithdeep0?_r=1&_t=ZS-96dxHYY0Ax2",
  instagram: "https://www.instagram.com/reel/DYvY8CJCHhn/?igsh=bThjdWQ5eHpvc3kx",
};

export const FAQS = [
  {
    q: "What is Ontario's Graduated Licensing System (GLS)?",
    a: "Ontario new drivers earn full driving privileges in two stages. After passing your written knowledge test you receive a G1 (Level 1), which has restrictions and requires an accompanying fully-licensed driver. You then progress to G2 (Level 2) by passing a road test, and finally to a full G licence by passing a second road test that includes highway driving. The full process generally takes a minimum of 12-20 months depending on whether you complete a Beginner Driver Education (BDE) course.",
  },
  {
    q: "What's the difference between the G2 and the full G road test?",
    a: "The G2 road test is taken after at least 12 months of holding your G1, or 8 months if you complete a BDE course. It focuses on city driving: turns, lane changes, parking, intersections, and basic observation. The full G road test is taken after at least 12 months of holding your G2 and includes highway driving: merging, exiting, lane changes at high speed, and defensive driving. Both tests are administered by DriveTest centres.",
  },
  {
    q: "How old do I need to be to start driving lessons?",
    a: "You must be at least 16 years old and hold a valid Ontario G1 licence before you can take any in-car driving lessons with us. For the G test you must already hold a G2 licence. We can start your lessons as soon as your G1 is issued.",
  },
  {
    q: "Can I shorten the wait time before my G2 road test?",
    a: "Yes. Ontario lets G1 holders take their G2 road test after 8 months instead of 12 after successfully completing a BDE course. The BDE Course is $699 plus tax for 30 hours online plus 10 hours in-car lessons.",
  },
  {
    q: "What is BDE?",
    a: "The Beginner Driver Education (BDE) Course is designed for new drivers with little or no driving experience. The package includes 30 hours online and 10 hours in-car lessons.",
  },
  {
    q: "Do you provide a car for the road test?",
    a: "Yes. The packages include a dual-brake car for the G2 / G local road test. Local road test car service is $200, with pickup and drop-off included within 4-5 km; otherwise extra charge.",
  },
  {
    q: "Are government road-test fees included in your packages?",
    a: "No. Road-test fees, licence fees, and any rescheduling charges paid directly to DriveTest are separate from Eknoor lesson and car-service pricing.",
  },
  {
    q: "Do taxes apply to lessons and packages?",
    a: "Yes. Package card prices are listed as plus applicable tax.",
  },
  {
    q: "What is your cancellation and refund policy?",
    a: "Payment is required in advance and is non-refundable, but transferrable to a friend or family member. Be punctual; late arrivals will result in shortened lesson time.",
  },
  {
    q: "Can I reschedule a single hourly lesson?",
    a: "Give 24 hrs notice to cancel the class otherwise charge may be in full except for emergency. Need 3 to 5 days notice in advance for the class.",
  },
  {
    q: "What if my road test is out of city?",
    a: "GTA and surrounding area is covered. Outside-GTA service has an extra charge based on distance, from $50 to $200.",
  },
  {
    q: "Can I get an early road test appointment?",
    a: "Yes. Early road test date is available for $50. WhatsApp or call with your earliest preferred date and nearest test centre.",
  },
  {
    q: "How early should I start preparing?",
    a: "For most G2 students we recommend starting 4\u20136 weeks before your road test date so we can space out lessons and finish with a mock test. For the full G, 2\u20134 weeks is usually enough if you already drive regularly on highways. New or nervous drivers should give themselves more time \u2014 we'll be honest about your readiness at every step.",
  },
  {
    q: "Do you offer pickup and drop-off?",
    a: "Pickup and drop-off is included for lessons, with downtown extra. Local road test pickup and drop-off is included within 4-5 km; otherwise extra charge.",
  },
  {
    q: "What should I bring to my lesson or road test?",
    a: "For lessons, bring your valid G1 or G2 licence (physical card) and wear comfortable, closed-toe shoes. For your road test, bring your G1/G2 licence, DriveTest appointment confirmation, and any required DriveTest payment.",
  },
  {
    q: "Are your instructors experienced?",
    a: "Yes. Eknoor focuses on calm, patient coaching, road-test preparation, and safe driving habits for G2 and G drivers.",
  },
  {
    q: "Do you teach nervous drivers or newcomers to Canada?",
    a: "Absolutely. Many of our students are nervous first-time drivers, returning drivers after a long break, or new Canadians adjusting to Ontario road rules. The larger packages are designed for more practice and confidence-first pacing. Let us know your situation when you call and we'll match you with the right plan.",
  },
  {
    q: "What payment methods do you accept?",
    a: "Payment can be done by cash, debit or credit card and Amex card. Payment is collected in advance to confirm your package or lesson.",
  },
  {
    q: "What happens if I fail my road test?",
    a: "Don't worry \u2014 it happens, and one bad test doesn't define you. We'll review your examiner's feedback together, identify exactly what to work on, and schedule additional hourly lessons (at our regular rates) to rebuild confidence in those specific skills. Many of our students pass on their second attempt within a few weeks.",
  },
  {
    q: "Is there a discount if I don't pass my G2 the first time?",
    a: "Yes. If you don't pass your G2 on the first attempt with us, take another package for your second attempt, and pass, you'll get $50 off that package. The discount applies to packages only — not single (hourly) lessons.",
  },
  {
    q: "How do I book a lesson or package?",
    a: "Tap any Call or WhatsApp button on this page. Tell us whether you want G2 or G prep, your road test date (if booked), your city, and your G1/G2 status. We'll confirm a package or hourly plan, take payment, and schedule your first lesson \u2014 usually within a day or two. We operate by appointment only \u2014 no walk-ins.",
  },
];
